<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    :color="color"
    viewBox="0 0 32 32"
  >
    <defs>
      <path
        id="vy5d06paca"
        d="M18.667 1.333c2.142 0 3.89 1.684 3.995 3.8l.005.2-.001 1.333H28c.736 0 1.333.598 1.333 1.334 0 .693-.528 1.263-1.205 1.327L28 9.333h-1.334v17.334c0 2.142-1.683 3.89-3.8 3.995l-.2.005H9.334c-2.142 0-3.89-1.684-3.995-3.8l-.005-.2V9.332L4 9.333c-.693 0-1.263-.528-1.327-1.205L2.667 8c0-.693.528-1.263 1.205-1.327L4 6.667h5.333V5.332c0-2.142 1.684-3.89 3.8-3.995l.2-.005h5.334zm-8.01 8H8v17.334c0 .693.529 1.262 1.205 1.327l.128.006h13.334c.693 0 1.262-.529 1.327-1.205l.006-.128V9.332h-2.65l-.017.001H10.657zm2.676 4c.693 0 1.263.53 1.328 1.205l.006.129v8c0 .736-.597 1.333-1.334 1.333-.693 0-1.262-.529-1.327-1.205L12 22.667v-8c0-.737.597-1.334 1.333-1.334zm5.334 0c.736 0 1.333.597 1.333 1.334v8c0 .736-.597 1.333-1.333 1.333-.737 0-1.334-.597-1.334-1.333v-8c0-.737.597-1.334 1.334-1.334zm0-9.333h-5.334c-.693 0-1.262.529-1.327 1.205L12 5.333v1.333h8V5.333c0-.693-.529-1.262-1.205-1.327L18.667 4z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g transform="translate(-1290 -873) translate(143 873) translate(1147)">
            <mask id="9dmy9z6k5b" fill="#fff">
              <use xlink:href="#vy5d06paca" />
            </mask>
            <use :fill="color" fill-rule="nonzero" xlink:href="#vy5d06paca" />
            <g :fill="color" mask="url(#9dmy9z6k5b)">
              <path d="M0 0H32V32H0z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-trash",
  components: {},
})
export class IconTrash extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconTrash;
</script>
